import * as React from "react";
import { toINR } from "../../../../service/numberFormat";
import { marginIntraEqHeading } from "../../marginConstants";
import { ISortProps } from "../../../../types/components/margin/marginTypes";
import MarginSort from "../../generic/marginSort";
import NoDataContainer from "../../../../generic/noDataContainer";

export interface IMarginIntraEqTableDskProps {
	tableData: Array<any>;
	filteredData: Array<any>;
	numOfRows: number;
	sortProps: ISortProps;
	setTableData: (tableData: Array<any>) => void;
}

const MarginIntraEqTableDsk: React.FC<IMarginIntraEqTableDskProps> = props => {
	return (
		<div className="mrgn_ieq_tbl table">
			<ul className="hdr_row">
				<li className="tr">
					<div className="td EdelCode">
						<span className="sort_cont">
							<MarginSort
								sortList={props.filteredData}
								sortedColName={props.sortProps.sortedColumnState.colName}
								sortKey="EdelCode"
								onSort={props.sortProps.onSort}
								colName={marginIntraEqHeading.edelCode}
							/>
						</span>
					</div>
					<div className="td NSESymbol">
						<span className="sort_cont">
							<MarginSort
								sortList={props.filteredData}
								sortedColName={props.sortProps.sortedColumnState.colName}
								sortKey="NSESymbol"
								onSort={props.sortProps.onSort}
								colName={marginIntraEqHeading.nseSymbol}
							/>
						</span>
					</div>
					<div className="td ISIN">
						<span className="sort_cont">
							<MarginSort
								sortList={props.filteredData}
								sortedColName={props.sortProps.sortedColumnState.colName}
								sortKey="ISIN"
								onSort={props.sortProps.onSort}
								colName={marginIntraEqHeading.isin}
							/>
						</span>
					</div>
					<div className="td IntradayMargin right">
						<span className="sort_cont">
							<MarginSort
								sortList={props.filteredData}
								sortedColName={props.sortProps.sortedColumnState.colName}
								sortKey="IntradayMargin"
								onSort={props.sortProps.onSort}
								colName={marginIntraEqHeading.intradayMargin}
							/>
						</span>
					</div>
				</li>
			</ul>

			{props.tableData.length ? (
				<ul className="mrgn_scrl_cont data_rows">
					{props.tableData.slice(0, props.numOfRows).map((row, index) => (
						<li className="tr" key={index}>
							<div className="td EdelCode robotoM">
								<span dangerouslySetInnerHTML={{ __html: row.EdelCode }}></span>
							</div>
							<div className="td NSESymbol">{row.NSESymbol}</div>
							<div className="td ISIN">{row.ISIN}</div>
							<div className="td IntradayMargin right">{toINR(row.IntradayMargin)}</div>
						</li>
					))}
				</ul>
			) : (
				<NoDataContainer txtHeading="No results found" />
			)}
		</div>
	);
};

export default MarginIntraEqTableDsk;
